import TherapySideApiService from "./utils/TherapyApi";

import type { ChoiceApi } from "@/Modules/Models/Api/Choice";

class SessionsApiConnector {
  constructor(private readonly ApiService: TherapySideApiService = new TherapySideApiService()) {}

  getChoices(choiceName: string): Promise<ChoiceApi[]> {
    return this.ApiService.get<void, ChoiceApi[]>({
      endpoint: `v2.0/choices/model?choice=${choiceName}`,
    });
  }
}

export default SessionsApiConnector;
